export class Clone {
    /**
     * 
     * @param value
     */
    //public static clone(value: any): any {

    //    // Object.assign does not perform a deep clone...!
    //    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Deep_Clone
    //    // TODO: REMOVE THIS Jquery reference when a valid clone method is implemented...


    //    if (Array.isArray(value)) {
    //        return $.extend(true, [], value);
    //    }
    //    else {
    //        return $.extend(true, {}, value);
    //    }




    //    //if (Array.isArray(value)) {
    //    //    let cloneArray = [];
    //    //    value.forEach((v, index) => {
    //    //        cloneArray.push(this.clone(v));
    //    //    });
    //    //    return cloneArray;
    //    //}

    //    //if (Array.isArray(value)) {
    //    //    return Object.assign([], value);
    //    //}
    //    //else {
    //    //    //return JSON.parse(JSON.stringify(value)); // angular.copy is not available in Angular 2 and Object.assign is not supported in all browsers.
    //    //    return Object.assign({}, value); // With polyfills Object.assign is now available
    //    //}
    //}

    public static extend(deep: boolean, target: any, object1?: any, ...objectN: any[]): any {

        // Object.assign does not perform a deep clone...!
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Deep_Clone
        // TODO: REMOVE THIS Jquery reference when a valid clone method is implemented...

        return $.extend(deep, target, object1, objectN);
    }
}